export function dispatchSettingsInvalidation(tabs) {
  if (!Array.isArray(tabs)) {
    return;
  }

  document.dispatchEvent(new CustomEvent("settings:invalidate", { detail: { tabs } }));
}

export function dispatchSettingsInvalidationHeader(response) {
  const encodedTabs = response?.headers?.get("X-Settings-Invalidate");
  if (!encodedTabs) {
    return;
  }

  try {
    dispatchSettingsInvalidation(JSON.parse(encodedTabs));
  } catch (_error) {
    // An invalid optional header must not interrupt the request consumer.
  }
}
